import { inject, injectable } from 'tsyringe';
import { NoRecommendationsReasons } from '../no-recommendations-reasons.enums';
import { ICondition, MatchResult } from './interfaces/condition.interface';
import { ConditionContext } from './interfaces/condition-context.interface';
import { Application } from '../../../models/application.model';
import {
  conditionType,
  ConditionType,
} from './decorators/condition-type.decorator';
import { LoggerService } from '../../logger.service';
import { kDITOWExtensionWrapper } from '../../../constants/injectionTokens';
import { IOWExtensionWrapper } from '../../../interfaces/ow-wrappers/ow-extension-wrapper.interface';

// -----------------------------------------------------------------------------
@injectable()
@conditionType(ConditionType.AppSpecific)
export class ConditionBlacklistApplicationInstalled implements ICondition {
  private readonly logger = LoggerService.getCategory(
    'ConditionBlacklistApplicationInstalled',
  );

  // ---------------------------------------------------------------------------
  public constructor(
    @inject(kDITOWExtensionWrapper)
    private readonly owExtensionWrapper: IOWExtensionWrapper,
  ) {}

  // ---------------------------------------------------------------------------
  // ICondition
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  public get id(): string {
    return this.logger.name;
  }

  // ---------------------------------------------------------------------------
  async match(context: ConditionContext): Promise<MatchResult> {
    const { application } = context;

    const match = await this.noBlacklistApplicationsFound(application);

    const matchReason = match ? null : NoRecommendationsReasons.BlackListedApp;

    return [match, matchReason];
  }

  // ---------------------------------------------------------------------------
  private async noBlacklistApplicationsFound(
    recommendedApp: Application,
  ): Promise<boolean> {
    const blacklistApps = recommendedApp.blacklistExtensionIds;

    const installedExtensions =
      await this.owExtensionWrapper.getInstalledAndEnabledExtensionUids();

    if (!installedExtensions || !blacklistApps) {
      this.logger.info('No installed or blacklist extensions found');
      return true;
    }

    for (const installedExtension of installedExtensions) {
      if (blacklistApps.includes(installedExtension)) {
        this.logger.info(`Blacklisted app: ${installedExtension} was detected`);
        return false;
      }
    }

    return true;
  }
}
